import styled from "@emotion/styled";

export const Container = styled.div`
    --gap-x: 1.5rem;
    padding-right: calc(var(--gap-x) * 0.5);
    padding-left: calc(var(--gap-x) * 0.5);
    margin-right: auto;
    margin-left: auto;
`;